import Vue from 'vue'
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'
import '@/assets/sass/overrides.sass'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)
const theme = {
    primary: '#8E2569',
    info: '#00CAE3',
    gray: '#E1E1E1',
}
const opts = {
    theme: {
        themes: {
            dark: theme,
            light: theme,
        },
    },
    icons: {
        iconfont: 'fa', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
}

export default new Vuetify(opts)
